/* PDP Balíček — "Vybrat variantu" scrolluje zpět na nákupní formulář */

(function () {
  'use strict';

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-scroll-to]');
    if (!btn) return;
    const target = document.querySelector(btn.dataset.scrollTo);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

})();
